import React from 'react';

import { CellTypeProps } from '../../interfaces';
import { BadgeIcon, Content } from './styles';

const Color: React.FC<CellTypeProps> = ({ badgeBackgroundColor, value }) => {
  return (
    <Content
      style={{ backgroundColor: badgeBackgroundColor ?? 'transparent' }}
      justifyBadge="center"
    >
      <BadgeIcon backgroundColor={value} />
    </Content>
  );
};

export default Color;
